import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  CreateUpdateTsAlertTemplateInput,
  TsAlertTemplateDto,
  TsAlertTemplateListItemDto,
  TsProfileFilterInput,
} from '@/api/types/tsTemplates';

interface SelectListItem {
  value: string;
  text: string;
}

// ABP conventional-controller mapping of
// Finkit.Tenants.User.TraderSurveillance.Templates.TsAlertTemplateAppService
// (no HTTP attributes -> pure convention; Get* => GET with Get prefix stripped;
// a non-CRUD verb like Set* => POST):
//   GetActiveAsync(filter)  -> GET    /api/app/ts-alert-template/active
//   GetDeletedAsync(filter) -> GET    /api/app/ts-alert-template/deleted
//   GetAsync(id)            -> GET    /api/app/ts-alert-template/{id}
//   SetEnabledAsync(id,on)  -> POST   /api/app/ts-alert-template/{id}/set-enabled
//   DeleteAsync(id)         -> DELETE /api/app/ts-alert-template/{id}
const BASE = '/api/app/ts-alert-template';

export const tsTemplatesApi = {
  async getActive(
    input: TsProfileFilterInput,
  ): Promise<PagedResult<TsAlertTemplateListItemDto>> {
    const { data } = await http.get<PagedResult<TsAlertTemplateListItemDto>>(`${BASE}/active`, {
      params: input,
    });
    return data;
  },

  async getDeleted(
    input: TsProfileFilterInput,
  ): Promise<PagedResult<TsAlertTemplateListItemDto>> {
    const { data } = await http.get<PagedResult<TsAlertTemplateListItemDto>>(`${BASE}/deleted`, {
      params: input,
    });
    return data;
  },

  async get(id: number): Promise<TsAlertTemplateDto> {
    const { data } = await http.get<TsAlertTemplateDto>(`${BASE}/${id}`);
    return data;
  },

  async create(input: CreateUpdateTsAlertTemplateInput): Promise<TsAlertTemplateDto> {
    const { data } = await http.post<TsAlertTemplateDto>(BASE, input);
    return data;
  },

  async update(id: number, input: CreateUpdateTsAlertTemplateInput): Promise<TsAlertTemplateDto> {
    const { data } = await http.put<TsAlertTemplateDto>(`${BASE}/${id}`, input);
    return data;
  },

  async getPriorities(): Promise<SelectListItem[]> {
    const { data } = await http.get<SelectListItem[]>(`${BASE}/priorities`);
    return data;
  },

  async setEnabled(id: number, enabled: boolean): Promise<void> {
    await http.post(`${BASE}/${id}/set-enabled`, null, { params: { enabled } });
  },

  async remove(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  },
};
